import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { CHART_COLORS } from './spacerLogUtils';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
  Filler
);

ChartJS.defaults.font.family =
  "ui-monospace, 'SF Mono', 'Cascadia Mono', Consolas, 'Roboto Mono', monospace";
ChartJS.defaults.font.size = 10.5;
ChartJS.defaults.color = CHART_COLORS.tick;

export const baseChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
};

export const gridScales = {
  x: { grid: { display: false }, ticks: { color: CHART_COLORS.tick, maxRotation: 0 } },
  y: { grid: { color: CHART_COLORS.grid }, beginAtZero: true, ticks: { color: CHART_COLORS.tick } },
};
